import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { renewToken } from "../services/apiService";
import { setMessage, setSubTitle } from "../stores/AppReducer";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";
import Icon, { IconType } from "./Icon";
import { BtnState, MessageType } from "../interfaces/App";

function NewToken() {
    const app = useSelector((appState: IApplicationState) => appState.app);
    const [newTokenLink, setNewTokenLnk] = useState(null);

    const dispatch = useDispatch<AppDispatch>();
    
    useEffect(() => {
        dispatch(setSubTitle(app.loggedIn ? "Profile" : "Login"));
    }, []);    
    const handleNewToken = () => {
        dispatch(renewToken(app.user.id)).then((res: any) => {
            if (res.type === "put/renewToken/fulfilled") {
                dispatch(setMessage(res.payload.data.msg));
                setNewTokenLnk(res.payload.data.link);
            }
        });
    };
    const copyClipboard = () => {
        navigator.clipboard.writeText(newTokenLink);
        dispatch(setMessage({msg: "Link in Zwischenablage kopiert", type: MessageType.success}))
    };

    return (
        <div className="">
            <div className="loginBox">
                Erneuere deinen Token.<br/>
                Alle Links mit dem alten Token werden damit ungültig.
                <br/>
                <button className="animButton" onClick={() => handleNewToken()} >Token erneuern</button>
                <br/>
                <br/>
                <div className="back_btn">
                    <a href="/#/login" >Zurück</a>
                </div>
                <div className="clear"/>
            </div>
            {newTokenLink && <div className="renew_token">
                <br/>
                <span>{newTokenLink}</span>
                <div className="hint_box">
                    Denke daran, deine Bookmarks zu aktualisieren.
                </div>
                <span>Kopiere Link in Zwischenablage</span>
                <button onClick={() => copyClipboard()}>
                    <Icon icon={IconType.arrowRight} state={BtnState.active} />
                </button>
            </div>}
        </div>
    );
}
export default (NewToken);

